import { BASE_URL, REGISTRY_API_URL } from "@src/utils";
import axios, { ServerResponse } from "../axios";
import { ICurationMenuServer, IMyPageData } from "@src/components/mypage/seemore/Interface";
import { AxiosResponse } from "axios";

// 더보기 메뉴 가져오기
export const getCurationMenu = () => {
  return axios.get<ServerResponse<ICurationMenuServer>>(
    `${BASE_URL}/v4/20240927/curation/SEE_MORE`,
  );
};

// 더보기 내 정보 가져오기
export const getMyInfo = () => {
  return axios.get<ServerResponse<IMyPageData>>(`${BASE_URL}/v3/mypage/me`);
};

// 더보기 레지스트리 숫자 가져오기
export const getRegistryItemCount = (uuid: string) => {
  return axios.get<{ count: number }>(
    `${REGISTRY_API_URL}/api/public/user/${uuid}/registry-items/count`,
  );
};

// 더보기 장바구니 숫자 가져오기
export const getCartItemCount = (uuid: string) => {
  return axios.get<{ count: number }>(`${REGISTRY_API_URL}/api/public/user/${uuid}/cart/count`);
};

// 더보기 카테고리 가져오기
export const getCategories = (): Promise<AxiosResponse<any>> => {
  return axios.get(`${REGISTRY_API_URL}/api/public/categories`);
};

// 카테고리 상세 조회 (children 포함)
export const getCategoryById = (id: number, ignoreEnabledForUser: boolean = false): Promise<AxiosResponse<any>> => {
  const params = ignoreEnabledForUser ? { ignoreEnabledForUser: 'true' } : {};
  return axios.get(`${REGISTRY_API_URL}/api/public/categories/${id}`, { params });
};
